<template>
  <div class="hello">
    <div class="main-header">
      <h2>Voice</h2>
      <div class="main-intro">
        <p>{{$t("i18nView.mainIntro")}}</p>
      </div>
      <div class="btn-area">
        <a class="btn-website" href="https://voice.com/" target="_blank">{{$t("i18nView.website")}}</a>

        <a v-if="isZh" href="javascript:void(0);" class="extra-link">{{$t("i18nView.view")}}</a>
        <a
          v-else
          target="_blank"
          href="https://voice.com/"
          class="extra-link"
        >{{$t("i18nView.view")}}</a>
      </div>
    </div>

    <div class="section">
      <h3>{{$t("i18nView.aboutVoice")}}</h3>
      <div class="content">
        <div @click="gotoWhatisVoice()" class="banner banner1">
          <h4>{{$t("i18nView.whatisVoice")}}</h4>
        </div>
        <div class="banner banner2" @click="gotoHowtoApply()">
          <h4>
            <span>{{$t("i18nView.howtoVoice")}}</span>
            <span class="beta">Beta</span>
          </h4>
        </div>
      </div>
    </div>
    <div class="section">
      <h3>{{$t("i18nView.whattosay")}}</h3>
      <div class="content">
        <div class="banner banner3" @click="gotoTeamSay()">
          <h4>
            <span class="icon icon-team"></span>
            <span class="icon-text">{{$t("i18nView.voicesay")}}</span>
          </h4>
        </div>
        <div class="banner banner4" @click="gotoCommunitySay()">
          <h4>
            <span class="icon icon-voice"></span>
            <span class="icon-text">{{$t("i18nView.communitysay")}}</span>
          </h4>
        </div>
      </div>
    </div>
    <div class="section">
      <h3>{{$t("i18nView.whatismore")}}</h3>
      <div class="banner vertical banner5" @click="gotoVoiceQA()">
        <span class="icon-miphone"></span>
        <span>{{$t("i18nView.voiceQA")}}</span>
        <span class="float-right icon-right-arrow"></span>
      </div>
      <div class="banner vertical banner6" @click="gotoVoiceRelated()">
        <span class="icon-menu"></span>
        <span>{{$t("i18nView.relativeReport")}}</span>
        <span class="float-right icon-right-arrow"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import tp from "tp-js-sdk";

export default {
  name: "HelloWorld",
  data() {
    return {
      isZh: true,
      isTP: false
    };
  },
  created() {
    this.isTP = !!tp.isConnected();

    if (this.isTP) {
      tp.fullScreen({
        fullScreen: 1
      });
      tp.setMenubar({
        flag: 1
      });
    }
    this.isZh = this.$i18n.locale === "zh";
  },
  methods: {
    gotoWhatisVoice() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039273452-%E4%BB%80%E4%B9%88%E6%98%AFVoice-"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039276952-What-is-Voice-";
      window.open(vHref);
    },
    gotoHowtoApply() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039677811-%E5%85%8D%E8%B4%B9%E7%94%B3%E8%AF%B7-Voice-%E5%86%85%E6%B5%8B%E7%89%88%E8%B4%A6%E5%8F%B7"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039277172-Apply-for-a-free-Voice-Beta-account";
      window.open(vHref);
    },
    gotoTeamSay() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039277912-Voice%E5%9B%A2%E9%98%9F%E8%AF%B4"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039681911-What-Voice-Team-Says-";
      window.open(vHref);
    },
    gotoCommunitySay() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039278032-%E7%A4%BE%E4%BC%9A%E5%A3%B0%E9%9F%B3"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039278852-What-Society-Says-";
      window.open(vHref);
    },
    gotoVoiceQA() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039276852-Voice%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039681311-FAQs-on-Voice";
      window.open(vHref);
    },
    gotoVoiceRelated() {
      var vHref = this.isZh
        ? "https://help.mytokenpocket.vip/hc/zh-cn/articles/360039279532-%E7%9B%B8%E5%85%B3%E6%8A%A5%E9%81%93"
        : "https://help.mytokenpocket.vip/hc/en-001/articles/360039683271-Related-News";
      window.open(vHref);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  max-width: 480px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 40px;
  background: url("../assets/main-bg.png") no-repeat;
  background-size: 100%;
  background-position: center top;
}
p {
  font-size: 14px;
  margin: 0;
  padding: 0;
  line-height: 1.8;
  color: #3a3b3d;
}
h1 {
  margin: 0 0 10px;
  font-size: 18px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

td {
  font-size: 12px;
  text-align: left;
  line-height: 1.5;
  padding: 8px 2px;
  border-bottom: 1px solid #e6e8ea;
}
table tr:last-child td {
  border-bottom: none;
}
th {
  text-align: left;
  font-size: 12px;
  font-weight: normal;
  color: #9ea0a5;
}

.inline-block {
  display: inline-block;
  vertical-align: middle;
}

.main-header {
  margin: 0 16px;
  min-height: 200px;
  background: url("../assets/phone.png") no-repeat;
  background-size: 45%;
  background-position: right center;
}

.main-header h2 {
  color: #fff;
  font-size: 44px;
  font-weight: normal;
  font-weight: 500;
  margin: 0;
  padding: 80px 10px 40px 20px;
}

.extra-link {
  float: right;
  display: inline-block;
  font-size: 12px;
  color: #d0021b;
  top: 3px;
  position: relative;
}
.main-intro {
  padding: 16px;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
}

.btn-area {
  position: relative;
  padding: 8px 12px;
  border-radius: 0 0 8px 8px;
  background-color: #fee7e7;
}

.btn-website {
  display: inline-block;
  text-align: center;
  font-size: 13px;

  padding: 4px 24px;

  background: linear-gradient(
    90deg,
    rgba(255, 113, 115, 1) 0%,
    rgba(244, 116, 255, 1) 100%
  );
  border-radius: 24px;
  border: none;
  color: #fff;
}

.beta {
  border-radius: 12px;
  color: #ea48db;
  font-size: 12px;
  background-color: #fff;
  padding: 2px 6px;
  margin-left: 2px;
  transform: scale(0.8);
}

.section {
  position: relative;
  margin: 16px;
  overflow: hidden;
}

h3 {
  font-size: 18px;
  margin: 12px 0;
}

.banner {
  position: relative;
  width: 48%;
  float: left;
  display: inline-block;
  margin-right: 2%;
  padding: 10px 12px;
  box-sizing: border-box;
  height: 72px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.banner span {
  vertical-align: middle;
}

.banner1 {
  background-image: url("../assets/banner1.png");
}
.banner2 {
  background-image: url("../assets/banner2.png");
}

.banner3 {
  background-image: url("../assets/banner3.png");
}
.banner4 {
  background-image: url("../assets/banner4.png");
}

h4 {
  color: #fff;
  margin: 2px 0;
  font-size: 15px;
}
h4 span {
  vertical-align: middle;
  display: inline-block;
}

.banner3 span,
.banner4 span,
.banner5 span,
.banner6 span {
  color: #d0021b;
}
.icon {
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.icon-team {
  position: absolute;
  top: 14px;
  background-image: url("../assets/team.png");
}
.icon-voice {
  position: absolute;
  top: 14px;
  background-image: url("../assets/voice.png");
}
.icon-text {
  margin-left: 20px;
}

.banner5,
.banner6 {
  width: 100%;
  margin: 0;
  background-color: #ffe0e0;
  height: 54px;
  margin: 8px 0;
  font-weight: bold;
  padding: 12px 16px;
  border-radius: 8px;
}

.banner3:after,
.banner4:after {
  content: "";
  display: block;
  position: absolute;
  width: 18px;
  height: 18px;
  background-image: url("../assets/right-arrow2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  right: 12px;
  bottom: 12px;
}

.content .banner:last-child {
  margin-right: 0;
  margin-left: 2%;
}
.float-right {
  float: right;
}

.icon-right-arrow {
  width: 12px;
  height: 12px;
  display: inline-block;
  background-image: url("../assets/right-arrow1.png");
  background-repeat: no-repeat;
  background-size: auto 12px;
  position: relative;
  top: 9px;
}

.icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-right: 4px;
}

.icon-miphone {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("../assets/icon-miphone.png") no-repeat;
  background-size: 100%;
  margin-right: 8px;
}
.icon-menu {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("../assets/icon-menu.png") no-repeat;
  background-size: 100%;
  margin-right: 8px;
}

.toast {
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.toast .img-wrap {
  position: relative;
  top: 50%;

  margin-top: -200px;
  margin-left: auto;
  margin-right: auto;
  width: 240px;
}

.icon-close {
  width: 30px;
  height: 30px;
  margin-top: 20px;
}

.img-wrap img {
  width: 100%;
}

@media screen and (max-width: 350px) {
  .banner {
    height: 66px;
  }
  .banner5,
  .banner6 {
    height: 54px;
  }
  p {
    font-size: 12px;
  }
  h4 {
    font-size: 13px;
  }
  .beta {
    position: absolute;
    right: 4px;
    top: 13px;
  }
}

@media screen and (min-width: 400px) {
  .banner {
    height: 88px;
  }

  .banner5,
  .banner6 {
    height: 54px;
  }
}
</style>
